import React, { createContext, useState, useContext, useEffect, useLayoutEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children, forceDark = false }) => {
  const [themeMode, setThemeMode] = useState('dark');
  /* const [themeMode, setThemeMode] = useState('system'); */
  /* const [systemPrefersDark, setSystemPrefersDark] = useState(() => (
    typeof window !== 'undefined'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : true
  )); */

  useEffect(() => {
    const stored = localStorage.getItem('themePreference');
    if (stored === 'light' || stored === 'dark') {
      setThemeMode(stored);
    }
    /* const stored = localStorage.getItem('themePreference') || 'system';
    setThemeMode(stored); */
  }, []);

  /* useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (event) => setSystemPrefersDark(event.matches);
    if (mql.addEventListener) mql.addEventListener('change', handler);
    else if (mql.addListener) mql.addListener(handler);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handler);
      else if (mql.removeListener) mql.removeListener(handler);
    };
  }, []); */

  const isDarkMode = forceDark ? true : themeMode === 'dark';
  /* const isDarkMode = themeMode === 'dark' || (themeMode === 'system' && systemPrefersDark); */

  useEffect(() => {
    if (!forceDark) {
      localStorage.setItem('themePreference', themeMode);
    }
  }, [themeMode, forceDark]);

  useLayoutEffect(() => {
    const legacyLink = document.getElementById('theme-style');
    if (legacyLink) legacyLink.remove();

    const ensureThemeLink = (id, href) => {
      if (document.getElementById(id)) return;
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    };

    ensureThemeLink('theme-style-dark', '/dark-theme.css');
    ensureThemeLink('theme-style-light', '/light-theme.css');

    document.documentElement.classList.toggle('dark-theme', isDarkMode);
    document.documentElement.classList.toggle('light-theme', !isDarkMode);
  }, [isDarkMode]);

  return (
    <ThemeContext.Provider value={{ isDarkMode, themeMode, setThemeMode }}>
      {children}
    </ThemeContext.Provider>
  );
};
